import { render } from "./lqQrCode.vue?vue&type=template&id=f0472d5c"
import script from "./lqQrCode.vue?vue&type=script&lang=js"
export * from "./lqQrCode.vue?vue&type=script&lang=js"

import "./lqQrCode.vue?vue&type=style&index=0&id=f0472d5c&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__